import { restClient } from '../../client';
import { CollaborativeAgreementExpired, CollaborativeAgreementExpiring, CollaborativeAgreementSigned, CollaborativeAgreementUnsigned } from '../collaboration/collaborativeAgreements';
import { StateExhibitExpired, StateExhibitExpiring, StateExhibitSigned } from '../stateExhibit';
import { UploadedProviderDocument } from './uploadedDocuments';


export enum ProviderDocumentType {
  collaborativeAgreementUnsigned = 'collaborative_agreement_unsigned',
  collaborativeAgreement = 'collaborative_agreement',
  collaborativeAgreementCounterSignatureRequired = 'collaborative_agreement_counter_signature_required',
  collaborativeAgreementCounterSigned = 'collaborative_agreement_counter_signed',
  collaborativeAgreementExpiring = 'collaborative_agreement_expiring',
  collaborativeAgreementExpired = 'collaborative_agreement_expired',
  stateExhibit = 'state_exhibit',
  stateExhibitExpiring = 'state_exhibit_expiring',
  stateExhibitExpired = 'state_exhibit_expired',
  uploadedProviderDocument = 'uploaded_provider_document',
}


export type ProviderCollaborativeAgreementDocument = {
  type: ProviderDocumentType.collaborativeAgreement;
  id: string;
  datetime: string;
  document: CollaborativeAgreementSigned;
};

export type ProviderCollaborativeAgreementDocumentUnsigned = {
  type: ProviderDocumentType.collaborativeAgreementUnsigned;
  id: string;
  datetime: null;
  document: CollaborativeAgreementUnsigned;
};

export type ProviderCollaborativeAgreementCounterSignatureRequired = {
  type: ProviderDocumentType.collaborativeAgreementCounterSignatureRequired;
  id: string;
  datetime: string;
  document: CollaborativeAgreementSigned;
};

export type ProviderCollaborativeAgreementCounterSigned = {
  type: ProviderDocumentType.collaborativeAgreementCounterSigned;
  id: string;
  datetime: string;
  document: CollaborativeAgreementSigned;
};

export type ProviderCollaborativeAgreementExpiring = {
  type: ProviderDocumentType.collaborativeAgreementExpiring;
  id: string;
  datetime: string;
  document: CollaborativeAgreementExpiring;
};

export type ProviderCollaborativeAgreementExpired = {
  type: ProviderDocumentType.collaborativeAgreementExpired;
  id: string;
  datetime: string;
  document: CollaborativeAgreementExpired;
};

export type ProviderStateExhibitDocument = {
  type: ProviderDocumentType.stateExhibit;
  id: string;
  datetime: string;
  document: StateExhibitSigned;
};

export type ProviderStateExhibitExpiringDocument = {
  type: ProviderDocumentType.stateExhibitExpiring;
  id: string;
  datetime: string;
  document: StateExhibitExpiring;
};

export type ProviderStateExhibitExpiredDocument = {
  type: ProviderDocumentType.stateExhibitExpired;
  id: string;
  datetime: string;
  document: StateExhibitExpired;
};

export type UploadedProviderDocumentItem = {
  type: ProviderDocumentType.uploadedProviderDocument;
  id: string;
  datetime: string;
  document: UploadedProviderDocument;
};

export type ProviderDocument =
  | ProviderCollaborativeAgreementDocument
  | ProviderCollaborativeAgreementDocumentUnsigned
  | ProviderCollaborativeAgreementCounterSignatureRequired
  | ProviderCollaborativeAgreementCounterSigned
  | ProviderCollaborativeAgreementExpiring
  | ProviderCollaborativeAgreementExpired
  | ProviderStateExhibitDocument
  | ProviderStateExhibitExpiringDocument
  | ProviderStateExhibitExpiredDocument
  | UploadedProviderDocumentItem;

export const getProviderDocuments = async (providerId: string) => restClient.request<{ data: ProviderDocument[] }>(`/api/v1/provider/${providerId}/documents`, {
  method: 'GET',
});
